import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { inject, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';
import { LoggerModule } from 'ngx-logger';
import { QuillModule } from 'ngx-quill';
import { LOGGER_CONFIG } from 'src/app/shared/configuration/loggerConfig';
import { MaterialModule } from 'src/app/shared/material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AdministrationPageComponent } from './modules/administration/administration-page/administration-page.component';
import { HomeComponent } from './modules/home/home.component';
import { LeftNavigationComponent } from './modules/left-navigation/left-navigation.component';
import { Globals } from './shared/configuration/globals';
import { SharedModule } from './shared/shared.module';
import { DisplayErrorsMessageModule } from './tinea-components/display-errors-message/display-errors-message.module';
import { CommonBaseModule } from './tinea-components/okta/common-base.module';
import { OktaModule } from './tinea-components/okta/okta/okta.module';
import { PagingModule } from './tinea-components/paging/paging.module';
import { TableModule } from './tinea-components/table/table.module';
import {ShivaVnfSecuredModule} from '../swagger-gen/vnf-secured/shiva-vnf-secured.module';
import {environment} from '../environments/environment';
import {ShivaWebPublicModule} from '../swagger-gen/web-public/shiva-web-public.module';
import {ShivaWebSecuredModule} from '../swagger-gen/web-secured/shiva-web-secured.module';

// AoT requires an exported function for factories
export function HttpLoaderFactory() {
  return new TranslateHttpLoader();
}

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        LeftNavigationComponent,
        AdministrationPageComponent,
    ],
    bootstrap: [AppComponent],
    exports: [
        BrowserAnimationsModule,
        BrowserModule,
    ], imports: [ShivaVnfSecuredModule.forRoot({ rootUrl: environment.apiUrl }),
        ShivaWebPublicModule.forRoot({ rootUrl: environment.publicApiUrl }),
        ShivaWebSecuredModule.forRoot({ rootUrl: environment.apiUrl }),
        MatSnackBarModule,
        SharedModule,
        TranslatePipe,
        TranslateDirective,
        OktaModule,
        GoogleMapsModule,
        FormsModule,
        ReactiveFormsModule,
        LoggerModule.forRoot(LOGGER_CONFIG),
        CoreModule,
        CommonBaseModule,
        TableModule,
        PagingModule,
        DisplayErrorsMessageModule,
        FormsModule,
        AppRoutingModule, // this one should ALWAYS be the last!
        BrowserModule,
        BrowserAnimationsModule,
        MatFormFieldModule,
        MatInputModule,
        QuillModule.forRoot(),
        MaterialModule], providers: [
        /*  Globals: have to be provided only here at the top level,
        as it's a singleton which values can be changed by another service */
        Globals,
        Title,
        DatePipe,
        CookieService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideTranslateService({
            loader: provideTranslateHttpLoader({ prefix: '/i18n/', suffix: '.json' }),
        }),
    ] })
export class AppModule {
  // for i18n datepipes
  constructor() {
    registerLocaleData(localeFr, 'fr');
  }
}
